module.exports = __webpack_public_path__ + "static/media/IsGuvenligi.f8e5897d.png";